import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class CameraExternal extends SnModel {
  @Expose()
  public externalAppliance: string;

  @Expose()
  public externalCameraId: string;

  @Expose()
  public externalMeta: any;

  @Expose()
  public externalType: string;

  @Expose()
  public host: any;

  @Expose()
  public port: any;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
